import { Badge } from "./badge";
import { Flame, AlertTriangle, Clock, TrendingUp } from "lucide-react";

const ScarcityBadge = ({ label, stockPercent, className = "" }) => {
  if (!label) return null;

  const getBadgeConfig = () => {
    switch (label) {
      case "Last Few!":
        return {
          icon: Flame,
          className: "bg-red-500 text-white border-red-500 animate-pulse",
          iconClassName: "text-white"
        };
      case "Almost Gone":
        return {
          icon: AlertTriangle,
          className: "bg-orange-500 text-white border-orange-500",
          iconClassName: "text-white"
        };
      case "Low Stock":
        return {
          icon: Clock,
          className: "bg-amber-500 text-white border-amber-500",
          iconClassName: "text-white"
        };
      case "Selling Fast":
        return {
          icon: TrendingUp,
          className: "bg-blue-500 text-white border-blue-500",
          iconClassName: "text-white"
        };
      default:
        return {
          icon: TrendingUp,
          className: "bg-slate-500 text-white border-slate-500",
          iconClassName: "text-white"
        };
    }
  };

  const config = getBadgeConfig();
  const Icon = config.icon;

  return (
    <Badge 
      className={`${config.className} ${className} gap-1 text-xs font-semibold`}
      data-testid="scarcity-badge"
    >
      <Icon className={`w-3 h-3 ${config.iconClassName}`} />
      {label}
    </Badge>
  );
};

export default ScarcityBadge;
